import React, { useEffect, useState } from "react";
import * as API from "../../framework/API/api";
import { utility } from "../../framework/utility/utilityProvider";
import { EditPageHeader } from "../../components/EditPageHeader";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useTranslation } from "../../locale/useTranslation";
import { ENTITYNAME, LOCALSTORAGE_KEY, TOAST_TYPES } from "../../framework/constant/constant";
import { uploadFileS3 } from "../AWS/awsHelper";
import ToastNotification from "../../components/ToastNotification";
import { PROMOTIONS_MEDIA_TYPE } from "./SocialMediaConstant";
import BossDialog from "../../components/BossDialog";
import { Checkbox } from "@progress/kendo-react-inputs";

const PostEditForm = (props) => {
    const lang = useTranslation();
    const item = props.item;
    const cancelEdit = props.cancelEdit;

    const blankDataItem = {
        ...item,
        Title: item?.Title ?? "",
        Description: item?.Description ?? "",
        PromotionsMediaType: item?.PromotionsMediaType ? {_id: item?.PromotionsMediaType, Description: utility.getKeyByValue(PROMOTIONS_MEDIA_TYPE, item?.PromotionsMediaType)} : {_id: PROMOTIONS_MEDIA_TYPE.IMAGE, Description: utility.getKeyByValue(PROMOTIONS_MEDIA_TYPE,PROMOTIONS_MEDIA_TYPE.IMAGE)},
        Caption: item?.Caption ?? "",
        Media: item?.Media ?? "",
        isReel: item?.isReel ?? false
    };

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [selectedFile, setSelectedFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [assetTypes, setAssetTypes] = useState([]);

    useEffect(() => {
        loadCombo();    
    }, []);

    const loadCombo = async () => {
        const assetTypeRes = Object.keys(PROMOTIONS_MEDIA_TYPE).map(key => ({
            _id: PROMOTIONS_MEDIA_TYPE[key],
            Description: key
        }));
        setAssetTypes(assetTypeRes);
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        setDataItem({ ...dataItem, [name]: value });
    };

    const onFileChange = (e) => {
        const files = Array.from(e.target.files);
        if (files.length === 0) return;
        const file = files[0];

        const existingName = dataItem.Asset?.fileName || (selectedFile?.file?.name || selectedFile?.name);
        if (existingName === file.name) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.file_already_attached_error_message });
            return;
        }

        const newFileObj = {
            file,
            isUploaded: false,
            fileName: file.name,
            format: file.name.split('.').pop()
        };

        setSelectedFile(newFileObj);
        setDataItem(prev => ({ ...prev, Media: file.name }));
        e.target.value = '';
    };

    const isValid = () => {
        if (!dataItem.Title || dataItem.Title.trim() === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title , message: lang.please_enter_title_error_message});
            return false;
        }
        const mediaVal = (dataItem.Media || "").trim();
        if (mediaVal.length === 0 && !selectedFile) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title , message: lang.please_attach_atleast_one_media_error_message });
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        if (!isValid()) return;
        setIsLoading(true);

        let mediaUrl = dataItem.Media || "";
        let finalAsset = item?.Asset || {};

        if (selectedFile) {
            const file = selectedFile?.file || selectedFile;
            let uploadRes;
            const isVideo = dataItem?.PromotionsMediaType?._id === PROMOTIONS_MEDIA_TYPE.VIDEO || file.type?.startsWith('video/') || /\.(mp4|mov|avi|mkv)$/i.test(file.name);

            try {
                if (isVideo) {
                    const credential = utility.getValue(LOCALSTORAGE_KEY.INSTANCE)?.StorageCredentials?.BossCloudMedia ?? {};
                    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);

                    uploadRes = await uploadFileS3(file, credential, (progress) => {}, company);
                } else {
                    uploadRes = await API.uploadImage(file);
                }

                console.log("Upload response:", uploadRes);
                const result = isVideo ? uploadRes?.data : uploadRes?.result;

                if (uploadRes?.success && result) {
                    mediaUrl = result?.secure_url || result?.url;
                    finalAsset = {
                        asset_id: result.asset_id,
                        public_id: result.public_id,
                        url: mediaUrl,
                        fileName: file.name,
                        format: file.name.split('.').pop(),
                        isUploaded: true
                    };
                } else {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: uploadRes?.message });
                    setIsLoading(false);
                    return;
                }
            } catch (err) {
                console.error('Upload error:', err);
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Unexpected upload error' });
                setIsLoading(false);
                return;
            }
        } else if ((dataItem.Media || "").trim().length > 0) {
            mediaUrl = dataItem.Media.trim();
            finalAsset = { url: mediaUrl };
        }

        const finalData = {
            ...item,
            _id: dataItem._id,
            SID: dataItem.SID,
            Title: dataItem.Title,
            Description: dataItem.Description,
            PromotionsMediaType: dataItem?.PromotionsMediaType?._id,
            Caption: dataItem.Caption,
            Media: mediaUrl,
            Asset: finalAsset,
            isReel: dataItem.isReel ??  false
        };

        console.log("Final Post Data:", finalData);

        try {
            const res = await API.saveData(ENTITYNAME.SM_PromotionsPosts, finalData);

            if (res.success) {
                utility.deleteLocalStorageItem(ENTITYNAME.SM_PromotionsPosts);
                if (props.refresh) props.refresh();
                if (cancelEdit) cancelEdit();
                if (props.onSaveData) props.onSaveData(res.data);
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            }
        } catch (err) {
            console.error("Save error:", err);
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Unexpected save error" });
        } finally {
            setIsLoading(false);
        }
    };

    const isVideoSelected = dataItem?.PromotionsMediaType?._id === PROMOTIONS_MEDIA_TYPE.VIDEO || dataItem?.PromotionsMediaType === PROMOTIONS_MEDIA_TYPE.VIDEO;

    return (
        <BossDialog
            title={dataItem?._id ? lang.edit_post_header : lang.create_post_header} onClose={cancelEdit} width="900px" height="auto">
            <div className="p-2">
                <EditPageHeader isLoading={isLoading} showTitle={false} onSubmit={handleSubmit} onCancel={cancelEdit}/>
                <div className="row mt-2">
                    <div className="col-4 form-group">
                        <label htmlFor="Title">{lang.title_label} *</label>
                        <input
                            type="text"
                            name="Title"
                            placeholder="Enter Title"
                            className="form-control form-control-sm"
                            value={dataItem.Title}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-4 form-group">
                        <label htmlFor="Description">{lang.description_label}</label>
                        <input
                            type="text"
                            name="Description"
                            placeholder="Enter Description"
                            className="form-control form-control-sm"
                            value={dataItem.Description}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-4 form-group">
                        <label htmlFor="PromotionsMediaType">{lang.media_type_label} *</label>
                        <DropDownList
                            name="PromotionsMediaType"
                            textField="Description"
                            dataItemKey="_id"
                            className="bg-white"
                            data={assetTypes}
                            value={dataItem.PromotionsMediaType}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-12 form-group">
                        <label htmlFor="Caption">{lang.caption_label}</label>
                        <input
                            type="text"
                            name="Caption"
                            placeholder="Enter Caption"
                            className="form-control form-control-sm"
                            value={dataItem.Caption}
                            onChange={onChange}
                        />
                    </div>
                </div>

                <div className="row mt-2 align-items-center">
                    <div className="col-6 form-group mb-0">
                        <label htmlFor="Media">{lang.media_label}</label>
                        <div className="input-group">
                            <input
                                name="Media"
                                className="form-control form-control-sm"
                                type="text"
                                placeholder="Enter URL or select file..."
                                value={dataItem.Media || ""}
                                onChange={onChange}
                            />
                            <button
                                type="button"
                                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                                style={{ height: "32px", margin: "0 0 0 3px" }}
                                onClick={() => document.getElementById("mediaFileInput").click()}
                            >
                                <i className="fa fa-plus" aria-hidden="true"></i>
                            </button>
                            <input
                                type="file"
                                id="mediaFileInput"
                                name="mediaFile"
                                onChange={onFileChange}
                                style={{ display: "none" }}
                            />
                        </div>
                    </div>
                    {isVideoSelected && (
                        <div className="col-6 pt-3">
                            <Checkbox
                                name="isReel"
                                label={lang.is_reel_label}
                                checked={dataItem.isReel}
                                onChange={(e) => setDataItem(prev => ({ ...prev, isReel: e.value !== undefined ? e.value : e.target.checked }))}
                            />
                        </div>
                    )}
                </div>
            </div>
        </BossDialog>
    );
};

export default PostEditForm;
